<template>
<!-- Site wrapper -->
  <div class="form-row">
    <div class="agrupamento col-xl-12">
      <div class="form-row col-xl-12 mt-2">
        <div class="form-group col-md-12 col-xl-12">
          <label for="inputClientes" class="required">Cliente</label>
          <v-select
            class="style-chooser"
            v-model="clienteSelecionado"
            @search="eventoDigitarBuscaPorCliente"
            @input="limparListaErros"
            :options="comboClientesDisponiveis"
            :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
            :filterable="false">
            <template v-slot:no-options>
              <em>Nenhum registro encontrado.</em>
            </template>
          </v-select>
          <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profile_data.f_profiles_clients']}}</div>
        </div>
        <div class="form-group col-md-6 col-lg-4 col-xl-4">
          <label for="inputEstados" class="required">Estado</label>
          <v-select
            class="style-chooser"
            v-model="estadoSelecionado"
            @search="eventoDigitarBuscaPorEstado"
            @input="limparListaErros"
            :options="comboEstadosDisponiveis"
            :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
            :filterable="false">
            <template v-slot:no-options>
              <em>Nenhum registro encontrado.</em>
            </template>
          </v-select>
          <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profiles_clients.f_state_name']}}</div>
        </div>
        <div class="form-group col-md-6 col-lg-8 col-xl-6">
          <label for="inputAreas" class="required">Área</label>
          <v-select
            class="style-chooser"
            v-model="areaSelecionada"
            @search="eventoDigitarBuscaPorArea"
            @input="limparListaErros"
            :options="comboAreasDisponiveis"
            :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
            :filterable="false">
            <template v-slot:no-options>
              <em>Nenhum registro encontrado.</em>
            </template>
          </v-select>
          <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profiles_clients.f_area_name']}}</div>
        </div>
        <div class="form-group text-right col-sm-12 col-md-6 col-lg-6 col-xl-1">
          <b-button class="botoes" style="margin-top: 2.1rem;" variant="outline-primary btn-sm" @click="adicionarNaLista()" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Adicionar</b-button>
        </div>
        <default-table
          :items="dadosPerfil.f_profiles_clients"
          :fields="fieldsPermissoes"
          :busy="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
          :tbody-tr-class="tabelaSemRegistros">
          <template #empty>
            <em>Nenhum registro encontrado.</em>
          </template>
          <template #cell(opcoes)="row">
            <b-button class="botoes" variant="outline-danger btn-sm" title="Excluir" @click="excluirDaLista(row.item)" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </template>
        </default-table>
      </div>
    </div>
    <div class="agrupamento col-xl-12 mt-2">
      <div class="form-row col-xl-12 mt-2">
        <div class="form-group col-md-12 col-xl-10">
          <label for="inputClientes">Tipos de Prazo</label>
          <treeSelect
            :options="comboTiposPrazosDisponiveis"
            v-model="idOpcaoComboPrazos"
            placeholder=""
            @select="selecionarOpcaoComboAcoes"
            :async="false"
            :cacheOptions="true"
            :default-expand-level="1"
            :disable-branch-nodes="true"
            :disableFuzzyMatching="true"
            loadingText="Carregando"
            noResultsText="Nenhum resultado encontrado"
            :backspaceRemoves="false"
            searchPromptText="Informe um termo para busca"
          />
          <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profile_data.f_appointment_types']}}</div>
        </div>
        <div class="form-group text-right col-sm-12 col-md-6 col-lg-6 col-xl-1">
          <b-button class="botoes" style="margin-top: 2.1rem;" variant="outline-primary btn-sm" @click="adicionarNaListaPrazos(tipoPrazoSelecionado)" :disabled="estaRealizandoProcessamento">Adicionar</b-button>
        </div>
        <default-table
          :items="dadosPerfil.f_appointment_types"
          :fields="fieldsTiposPrazo"
          :busy="estaRealizandoProcessamento"
          :tbody-tr-class="tabelaSemRegistros">
          <template #empty>
            <em>Nenhum registro encontrado.</em>
          </template>
          <template #cell(opcoes)="row">
            <b-button class="botoes" variant="outline-danger btn-sm" title="Excluir" @click="removerTipoPrazo(row.item)" :disabled="estaRealizandoProcessamento">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </template>
        </default-table>
      </div>
    </div>
  </div>
</template>

<script>
import Cliente from '../layoutPerfil/js/cliente'
export default Cliente
</script>

<style scoped>
@import "../layoutPerfil/scss/cliente.scss";
</style>
